module.exports = "/_next/static/images/instagram-c-icon-12f93960ebe37ce4e4b2702eb3770329.svg";